<template>
    <vx-expandable-card data-test="stripe-customer-card">
        <template v-slot:header> Stripe Customer </template>
        <template v-slot:content>
            <div class="flex flex-col gap-4 mt-3">
                <vx-button
                    v-if="props.stripeId"
                    :href="`https://dashboard.stripe.com/customers/${encodeURIComponent(props.stripeId)}`"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="w-full"
                    color="muted"
                    size="lg"
                >
                    <span class="inline-block">Open in Stripe</span>
                    <font-awesome-icon widthAuto :icon="faArrowUpRightFromSquare"></font-awesome-icon>
                </vx-button>
                <vx-button v-else class="w-full" color="muted" size="lg" disabled>
                    This group is not linked to a Stripe customer
                </vx-button>
            </div>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxButton, VxExpandableCard } from '@voxie/frontend-components';

const props = defineProps({
    stripeId: {
        type: String,
        default: null,
    },
});
</script>
